import styled from "styled-components";
import { spacingExtender } from "ui-components";

const SidebarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-start;
  min-width: 0;
  height: calc(100vh - 60px);
  overflow: auto;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadow};
  ${() => spacingExtender({ padding: "3" })};
`;

const Header = styled.div`
  padding: 10px 0;
  width: 100%;
`;

const StepsWrapper = styled.div`
  padding: 20px 0;
  width: 100%;
`;

const StepDescription = styled.div`
  width: 100%;
  font-size: 12px;

  div:not(:first-of-type) {
    margin-top: 0.5rem;
  }
`;

const StepLabel = styled.div`
  display: flex;
  ${() => spacingExtender({ paddingL: 1 })}
`;

const StepWrapper = styled.div`
  flex-direction: column;
  ${() => spacingExtender({ paddingL: 1 })}
`;

export {
  Header,
  SidebarWrapper,
  StepsWrapper,
  StepDescription,
  StepLabel,
  StepWrapper
};



// WEBPACK FOOTER //
// ./src/common/styled/sidebar.js